module.exports = "/_next/static/images/reference-snizek-c8412ed4bd305fdbd770c0e1ee128d7a.jpg";